<div class="form-group m-form__group row">
    <app-dynamic *ngFor="let item of getFields()" 
        [class]="getSizeClass(item)" 
        [attribute]="item"
        [envOptions]="getEnvOptions()"
        (onEmit)="execute($event)" >
    </app-dynamic>
</div>